"use client";
import { AnimatedSection } from "@/components/Home/animated-section";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import Blog from "../Resource/Blog";
export default function News({ blogList }: { blogList: Blog.BlogListItem[] }) {
	const t = useTranslations("nav");
	const tb = useTranslations("blog");
	const tt = useTranslations("");
	const tc = useTranslations("common");

	let [data, setData] = useState(blogList?.length ? blogList : []);

	useEffect(() => {
		const monthNames = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		];
		const newData = data.map((item) => {
			const date = new Date(item.blog_upload_time);
			const formateDate = `${tc(monthNames[date.getMonth()])} ${date.getDate()}, ${date.getFullYear()}`;
			return {
				...item,
				formateDate,
			};
		});
		setData(newData);
	}, []);
	console.log("blogList", data);

	return (
		<div className="w-full bg-[#EBEBEB] max-md:py-12 max-sm:py-10 md:py-14 lg:py-16 xl:py-20 2xl:pt-24">
			<div className="container mx-auto  ">
				<div className="flex max-md:justify-center">
					<div className="mb-[40px] flex justify-between">
						<div className="flex flex-col justify-center gap-2 max-md:items-center">
							<AnimatedSection animationClass="animate__fadeInUp">
								<h2 className="font-poppins text-[40px] !font-bold leading-[52px]  max-md:!text-[32px] max-md:!font-normal max-md:!leading-[33px]">
									{tt("home.Fresh Updates")}
								</h2>
							</AnimatedSection>
							<AnimatedSection animationClass="animate__fadeInLeft">
								<h3 className="font-abeezee text-[16px]">{tt("home.newLife")} </h3>
							</AnimatedSection>
						</div>
					</div>
				</div>
				<AnimatedSection animationClass="animate__fadeInRight">
					<div className="grid grid-cols-4 gap-6 max-xl:grid-cols-2 max-md:hidden max-md:grid-cols-1">
						{data.map(
							(item, index) =>
								index < 4 && (
									<Link
										href={`/blog/${item.blog_slug}`}
										key={item.blog_id}
										className="group overflow-hidden text-[#333] hover:!text-[#A1A6A6]"
									>
										<div className="flex flex-col gap-2 ">
											{item.blog_cover_type ? (
												<Image
													alt={item.blog_title}
													className="w-full object-cover transition-all duration-300 ease-in-out group-hover:scale-105 max-md:h-[330px] max-sm:h-[220px] md:h-[300px] lg:h-[330px] xl:h-[350px] 2xl:h-[372px]"
													src={item.blog_cover_origin}
													width={800}
													height={600}
													priority={index === 0}
													loading={index === 0 ? "eager" : "lazy"}
												/>
											) : (
												<video
													autoPlay
													muted
													loop
													playsInline
													className="w-full object-cover max-md:h-[330px] max-sm:h-[220px] md:h-[300px] lg:h-[330px] xl:h-[350px] 2xl:h-[372px]"
													src={item.blog_cover_origin}
												/>
											)}
											<p className="mt-4 self-start font-poppins text-black">{(item as any).formateDate}</p>
											{/* <div className="self-start font-bold text-main text-[12px]">——</div> */}
											<h3 className="line-clamp-1 font-poppins text-xl font-bold">{item.blog_title}</h3>
											{/* <div className="mt-2 flex items-center text-[#666666]">
												<i className="far fa-calendar-alt mr-2"></i>
												<span>{process.env.NEXT_PUBLIC_COMPANY_NAME}</span>
											</div> */}
											<p
												className="mb-4 line-clamp-2 min-h-[44px] font-abeezee leading-[30px] text-[#1e1e1e] md:min-h-[44px]"
												dangerouslySetInnerHTML={{ __html: item.blog_excerpt }}
											></p>
										</div>
									</Link>
								),
						)}
					</div>
					{/* 移动端显示 */}
					<div className="items-center justify-center max-md:flex md:hidden">
						<Swiper className="w-full" slidesPerView={1}>
							{data.map(
								(item, index) =>
									index < 4 && (
										<SwiperSlide key={index}>
											<Link
												href={`/blog/${item.blog_slug}`}
												key={item.blog_id}
												className="group overflow-hidden text-[#333] hover:!text-[#A1A6A6]"
											>
												<div className="flex flex-col gap-2 ">
													{item.blog_cover_type ? (
														<Image
															alt={item.blog_title}
															className="w-full object-cover transition-all duration-300 ease-in-out group-hover:scale-105 max-md:h-[330px] max-sm:h-[220px] md:h-[300px] lg:h-[330px] xl:h-[350px] 2xl:h-[372px]"
															src={item.blog_cover_origin}
															width={800}
															height={600}
															priority={index === 0}
															loading={index === 0 ? "eager" : "lazy"}
														/>
													) : (
														<video
															autoPlay
															muted
															loop
															playsInline
															className="w-full object-cover max-md:h-[330px] max-sm:h-[220px] md:h-[300px] lg:h-[330px] xl:h-[350px] 2xl:h-[372px]"
															src={item.blog_cover_origin}
														/>
													)}
													<p className="mt-4 self-start font-poppins text-black">
														{(item as any).formateDate}
													</p>
													{/* <div className="self-start font-bold text-main text-[12px]">——</div> */}
													<h3 className="line-clamp-1 font-poppins text-xl font-bold">{item.blog_title}</h3>
													{/* <div className="mt-2 flex items-center text-[#666666]">
												<i className="far fa-calendar-alt mr-2"></i>
												<span>{process.env.NEXT_PUBLIC_COMPANY_NAME}</span>
											</div> */}
													<p
														className="mb-4 line-clamp-2 min-h-[44px] font-abeezee leading-[30px] text-[#1e1e1e] md:min-h-[44px]"
														dangerouslySetInnerHTML={{ __html: item.blog_excerpt }}
													></p>
												</div>
											</Link>
										</SwiperSlide>
									),
							)}
						</Swiper>
					</div>
				</AnimatedSection>
			</div>
		</div>
	);
}
